import { MESSAGES } from '@/features/player/schema/mutate-player-schema';
import { avatarRule, cityRule, optionalPhoneRule, zipCodeRule } from '@/validation';
import * as yup from 'yup';

type MutateCoachAvatar = {
  uri?: string | null | undefined;
  fileSize?: number | undefined;
};

export type MutateCoachForm = {
  phoneNumber?: string | null | undefined;
  countryCode?: string | null | undefined;
  country: string;
  city: string;
  state: string;
  zipCode: string;
  avatar?: MutateCoachAvatar | null | undefined;
};

export const mutateCoachSchema = (): yup.ObjectSchema<MutateCoachForm> =>
  yup.object({
    phoneNumber: optionalPhoneRule(MESSAGES.phoneNumberDigitsRange).optional().nullable(),
    countryCode: yup.string().optional().nullable(),
    country: yup.string().trim().defined(),
    city: cityRule(),
    state: yup.string().trim().defined(),
    zipCode: zipCodeRule(),
    avatar: avatarRule(MESSAGES.fieldRequired, MESSAGES.avatarTooLarge),
  });
